var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card-caracteristica-produto" }, [
    _vm._m(0),
    _c("div", { staticClass: "caracteristicas" }, [
      _c("div", [
        _c("span", { staticClass: "title-item" }, [_vm._v("Produto")]),
        _c("span", { staticClass: "descricao-item" }, [
          _vm._v(_vm._s(_vm.ativo_prop.title))
        ])
      ]),
      _vm.ativo_prop.idTProduto != 5
        ? _c("div", [
            _vm.ativo_prop.idTProduto == 1 || _vm.ativo_prop.idTProduto == 4
              ? _c("span", { staticClass: "title-item" }, [_vm._v("Emissor")])
              : _vm._e(),
            _vm.ativo_prop.idTProduto == 2 ||
            _vm.ativo_prop.idTProduto == 10 ||
            _vm.ativo_prop.idTProduto == 3
              ? _c("span", { staticClass: "title-item" }, [
                  _vm._v("Risco de Crédito")
                ])
              : _vm._e(),
            _vm.ativo_prop.idTProduto == 7 || _vm.ativo_prop.idTProduto == 8
              ? _c("span", { staticClass: "title-item" }, [_vm._v("Gestor")])
              : _vm._e(),
            _vm.ativo_prop.idTProduto == 6 || _vm.ativo_prop.idTProduto == 11
              ? _c("span", { staticClass: "title-item" }, [_vm._v("Empresa")])
              : _vm._e(),
            _vm.ativo_prop.idTProduto != 8
              ? _c("span", { staticClass: "descricao-item" }, [
                  _vm._v(_vm._s(_vm.ativo_prop.emissor))
                ])
              : _vm._e(),
            _vm.ativo_prop.idTProduto == 8
              ? _c("span", { staticClass: "descricao-item" }, [
                  _vm._v(_vm._s(_vm.ativo_prop.gestor))
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _c("div", [
        _c("span", { staticClass: "title-item" }, [_vm._v("Estrátegia")]),
        _c("span", { staticClass: "descricao-item" }, [
          _vm._v(_vm._s(_vm.ativo_prop.estrategia))
        ])
      ]),
      _c("div", [
        _c("span", { staticClass: "title-item" }, [
          _vm._v("Índice de Referência")
        ]),
        _c("span", { staticClass: "descricao-item" }, [
          _vm._v(_vm._s(_vm.ativo_prop.referencia))
        ])
      ]),
      _vm.ativo_prop.taxa > 0
        ? _c("div", [
            _c("span", { staticClass: "title-item" }, [_vm._v("Taxa")]),
            _c("span", { staticClass: "descricao-item" }, [
              _vm._v(
                _vm._s(_vm.ativo_prop.taxa > 0 ? _vm.ativo_prop.taxa : "100")
              )
            ])
          ])
        : _vm._e(),
      _c("div", [
        _c("span", { staticClass: "title-item" }, [_vm._v("FGC")]),
        _c("span", { staticClass: "descricao-item" }, [
          _vm._v(
            _vm._s(
              _vm.ativo_prop.fgcDescricao
                ? _vm.ativo_prop.fgcDescricao
                : "Sem registros"
            )
          )
        ])
      ]),
      _c("div", [
        _c("span", { staticClass: "title-item" }, [_vm._v("Indexador")]),
        _c("span", { staticClass: "descricao-item" }, [
          _vm._v(_vm._s(_vm.ativo_prop.indexador))
        ])
      ]),
      _c("div", [
        _c("span", { staticClass: "title-item" }, [_vm._v("Data Aplicação")]),
        _c("span", { staticClass: "descricao-item" }, [
          _vm._v(
            _vm._s(_vm.dateHelper.formatDate(_vm.ativo_prop.dataInvestimento))
          )
        ])
      ]),
      _vm.ativo_prop.vencimento != undefined
        ? _c("div", [
            _c("span", { staticClass: "title-item" }, [_vm._v("Vencimento")]),
            _c("span", { staticClass: "descricao-item" }, [
              _vm._v(
                _vm._s(_vm.dateHelper.formatDate(_vm.ativo_prop.vencimento))
              )
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-caracteristica" }, [
      _c("span", [_vm._v("Caracteristicas do produto")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }